import queryString from "query-string";

import getCookie from "../../helpers/Cookies";

/**
 * Parâmetros de atribuição que o backend consome no checkout.
 * Ficam em cookie (setados na landing) e/ou na query string do checkout.
 * `referral_id` identifica quem indicou (MGM).
 */
export const TRACKING_PARAM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "gclid",
  "referral_id",
];

/**
 * Monta o urlParams enviado ao backend: query string do checkout com os
 * cookies de atribuição sobrescrevendo quando presentes.
 */
export const buildTrackingUrlParams = locationSearch => {
  const urlParams = queryString.parse(locationSearch);

  TRACKING_PARAM_KEYS.forEach(key => {
    const value = getCookie(key);
    if (value) urlParams[key] = value;
  });

  return urlParams;
};
